<template>
  <b-form-group v-if="hasCode">
    <b-input-group>
      <b-input-group-text slot="append" class="p-0">
        <b-button
          :id="`copy-provcode-${node.uid}`"
          variant="link"
          class="py-0 m-0 text-secondary"
          @click="copyToClipboard"
          @mouseout="onHoverOut"
        >
          <font-awesome-icon icon="paste" />
        </b-button>
      </b-input-group-text>
      <b-form-input size="sm" v-model.trim="node.provcode" />
    </b-input-group>
    <b-tooltip :target="`copy-provcode-${node.uid}`" :title="tooltipMessage" :show="showTooltip" triggers />
  </b-form-group>
</template>

<script>
export default {
  props: {
    node: { type: Object, required: true }
  },

  data: () => ({
    showTooltip: false,
    tooltipMessage: 'Copied to clipboard!'
  }),

  computed: {
    hasCode() {
      return !!this.node.provcode
    }
  },

  methods: {
    copyToClipboard() {
      let passed = this
      // wrap the code in double-quotes
      this.$copyText(`"${this.node.provcode}"`)
        .then(event => {
          passed.showTooltip = true
        })
        .catch(e => {})
    },
    onHoverOut(event) {
      this.showTooltip = false
    }
  }
}
</script>

<style></style>
